
import { generateInstallationDocs } from "./installationDocs";
import type { ServerStatusData } from "../components/dashboard/ServerStatusSection";

export const handleExport = (
  type: string,
  serverStatus: ServerStatusData
): void => {
  let content = '';
  let fileName = '';
  let fileType = '';
  
  // Osiguramo validan objekt za serverStatus
  const safeServerStatus = serverStatus || {
    cpu: "N/A",
    memory: "N/A",
    disk: "N/A",
    uptime: "N/A"
  };
  
  // Generate file content based on export type
  if (type === "JSON") {
    // JSON export - server status report
    const reportData = {
      timestamp: new Date().toISOString(),
      serverStatus: safeServerStatus
    };
    content = JSON.stringify(reportData, null, 2);
    fileName = `7gc-server-report-${new Date().toLocaleDateString().replace(/\//g, '-')}.json`;
    fileType = "application/json";
  } 
  else if (type === "CSV") {
    // CSV export - simple server status
    content = `Timestamp,CPU,Memory,Disk,Uptime\n${new Date().toISOString()},${safeServerStatus.cpu},${safeServerStatus.memory},${safeServerStatus.disk},${safeServerStatus.uptime}`;
    fileName = `7gc-server-report-${new Date().toLocaleDateString().replace(/\//g, '-')}.csv`;
    fileType = "text/csv";
  }
  else if (type === "PDF") {
    // For PDF we'll actually just create a text file with installation instructions
    content = generateInstallationDocs();
    fileName = `7gc-dashboard-installation-${new Date().toLocaleDateString().replace(/\//g, '-')}.txt`;
    fileType = "text/plain";
  }
  else if (type === "INSTALL") {
    // Complete installation document
    content = generateInstallationDocs();
    fileName = `7gc-dashboard-full-installation-guide.txt`;
    fileType = "text/plain";
  }
  
  // Create blob and download
  const blob = new Blob([content], { type: fileType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
